import React, { useState, useEffect } from 'react';
import Partner from './partner';
import Pricing from './pricing';
import Review from "./review";
import Faq from "./faq";
import Footer from "./landingfooter";
import './landing.css';
import teme from '../../assets/images/teme.png';
import personne from '../../assets/images/Personne.png';
import icon1 from '../../assets/images/icon1.png';
import icone2 from '../../assets/images/icone2.png';
import icone3 from '../../assets/images/icone3.png';
import uno from '../../assets/images/uno.png';
import tablet from '../../assets/images/tablet.png';
import credit from '../../assets/images/credit.png';
import table from '../../assets/images/table.png';
import doctorImg from '../../assets/images/doctor.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { useNavigate, useLocation } from 'react-router-dom';
import BookAppointment from '../clientviews/Patientmanagment/bookapttempoluwasheyi';
import 'animate.css';

// 


function App() {
  const navigate = useNavigate();
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Handle navbar toggle
  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  // Handle signup click - utilisez la navigation existante
  const handleSignUpClick = (e) => {
    e && e.preventDefault();
    navigate('/Clientsignup');
  };

  // Handle scroll for navbar appearance change
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  // Fonction améliorée pour le défilement fluide
  const scrollToSection = (e) => {
    e.preventDefault();
    const targetId = e.target.getAttribute('href');
    
    // Fermer le menu si on est en mobile
    if (isNavOpen) {
      setIsNavOpen(false);
    }
    
    // Attendre que le menu se ferme avant de scroller (important sur mobile)
    setTimeout(() => {
      const targetElement = document.querySelector(targetId);
      
      if (targetElement) {
        // Calculer l'offset en tenant compte de la navbar
        const navbarHeight = document.querySelector('.navbar').offsetHeight;
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        
        // Scroll avec offset pour la navbar
        window.scrollTo({
          top: targetPosition - navbarHeight - 20, // 20px d'espace supplémentaire
          behavior: 'smooth'
        });
      }
    }, isNavOpen ? 300 : 0); // Petit délai si le menu était ouvert
  };

  return (
    <div className='crainte'>
      <div className="mt-hero-banner">
        {/* Navbar */}
        <nav className={`navbar navbar-expand-lg mt-navbar ${isScrolled ? 'scrolled' : ''}`}>
          <div className="container mt-2">
            <a className="navbar-brand" href="">
              MED<span className="mt-brand-accent">TINZ</span>
            </a>
            <button
              className="navbar-toggler border border-white"
              type="button"
              onClick={toggleNav}
              aria-expanded={isNavOpen}
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className={`collapse navbar-collapse mt-navbar-collapse ${isNavOpen ? 'show' : ''}`} id="navbarTogglerDemo02">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0 mt-navbar-nav">
                <li className="nav-item mt-nav-item">
                  <a className="nav-link mt-nav-link" href="#features" onClick={scrollToSection}>Features</a>
                </li>
                <li className="nav-item mt-nav-item">
                  <a className="nav-link mt-nav-link" href="#contact" onClick={scrollToSection}>Contact us</a>
                </li>
                <li className="nav-item mt-nav-item">
                  <a className="nav-link mt-nav-link" href="#pricing" onClick={scrollToSection}>Pricing</a>
                </li>
                <li className="nav-item mt-nav-item">
                  <a className="nav-link mt-nav-link" href="#about" onClick={scrollToSection}>About Us</a>
                </li>
              </ul>
              <div className="mt-buttons-container" role="group">
                <button
                  className="mt-signup-btn"
                  onClick={handleSignUpClick}
                >
                  Sign Up
                </button>
                {/* <a href="#appointment" className="mt-appointment-btn" onClick={scrollToSection}>
                  Book Appointment
                </a> */}
              </div>
            </div>
          </div>
        </nav>

        {/* Hero Content */}
        <div className="mt-hero-content container">
          <div className="mt-hero-row">
            <div className="mt-hero-text">
              <h1 className="mt-hero-title">
                Transform your hospital <br />
                Operations with AI driven <span className="mt-accent-text">Efficiency</span>
              </h1>
              <p className="mt-hero-subtitle">
                We provide many features that you can use cheaply and easily. Try it now <br />
                and get an interesting promo
              </p>
              <button className="mt-demo-btn">Watch a demo</button>
            </div>

            <div className="mt-hero-image">
              <img src={personne} alt="Healthcare professional" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
      <Partner />
      <div className="medtech-features-section py-5">
        <div className="medtech-container container my-4" id='features'>
          <div className="medtech-row row my-4 align-items-center" data-aos="fade-in">
            <div className="medtech-col-heading col-lg-3 col-md-12 mb-3">
              <span className="medtech-subtitle">Our features</span>
              <h4 className="medtech-title">Easy, Simple, Affordable</h4>
            </div>

            <div className="medtech-col-description col-lg-7 col-md-12 mb-3">
              <p className="medtech-description mt-lg-4">
                Our platform helps your business in managing expenses. These are some of the reasons why you should use our platform in managing business finances.
              </p>
            </div>

            <div className="medtech-col-image col-lg-2 col-md-12 text-center mb-3">
              <div data-aos="zoom-in" data-aos-delay="300">
                <img src={teme} alt="Features icon" className="medtech-header-image img-fluid" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="medtech-feature-item col-lg-4 col-md-6 col-sm-12 mb-4">
              <div
                className="medtech-feature-card p-3 h-100 transition-all hover-shadow"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <div className="text-center text-lg-start">
                  <div className="medtech-image-wrapper mb-3">
                    <img
                      src={uno}
                      alt="Patient Management"
                      className="medtech-feature-icon img-fluid"
                    />
                  </div>
                  <h5 className="medtech-feature-title mb-3">Patient Management</h5>
                  <p className="medtech-feature-description">No need to pay manually, we provide automatic invoice payment service! Set a payment schedule and you're done, it's that easy!</p>
                </div>
              </div>
            </div>
            <div className="medtech-feature-item col-lg-4 col-md-6 col-sm-12 mb-4">
              <div
                className="medtech-feature-card p-3 h-100 transition-all hover-shadow"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="text-center text-lg-start">
                  <div className="medtech-image-wrapper mb-3">
                    <img
                      src={table}
                      alt="Reporting & Analytics"
                      className="medtech-feature-icon img-fluid"
                    />
                  </div>
                  <h5 className="medtech-feature-title mb-3">Reporting & Analytics</h5>
                  <p className="medtech-feature-description">Still writing manual expenses? Our platform breaks down every expense you log down to the millisecond!</p>
                </div>
              </div>
            </div>
            <div className="medtech-feature-item col-lg-4 col-md-6 col-sm-12 mb-4">
              <div
                className="medtech-feature-card p-3 h-100 transition-all hover-shadow"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <div className="text-center text-lg-start">
                  <div className="medtech-image-wrapper mb-3">
                    <img
                      src={credit}
                      alt="Insurance Integration"
                      className="medtech-feature-icon img-fluid"
                    />
                  </div>
                  <h5 className="medtech-feature-title mb-3">Insurance Integration</h5>
                  <p className="medtech-feature-description">Have more than 1 bank account or credit/debit card? Our platform is already integrated with many banks around the world, for easier payments!</p>
                </div>
              </div>
            </div>
            <div className="medtech-feature-item col-lg-4 col-md-6 col-sm-12 mb-4">
              <div
                className="medtech-feature-card p-3 h-100 transition-all hover-shadow"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <div className="text-center text-lg-start">
                  <div className="medtech-image-wrapper mb-3">
                    <img
                      src={uno}
                      alt="Laboratory Records"
                      className="medtech-feature-icon img-fluid"
                    />
                  </div>
                  <h5 className="medtech-feature-title mb-3">Laboratory Records</h5>
                  <p className="medtech-feature-description">No need to pay manually, we provide automatic invoice payment service! Set a payment schedule and you're done, it's that easy!</p>
                </div>
              </div>
            </div>
            <div className="medtech-feature-item col-lg-4 col-md-6 col-sm-12 mb-4">
              <div
                className="medtech-feature-card p-3 h-100 transition-all hover-shadow"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                <div className="text-center text-lg-start">
                  <div className="medtech-image-wrapper mb-3">
                    <img
                      src={table}
                      alt="Appointment Scheduling"
                      className="medtech-feature-icon img-fluid"
                    />
                  </div>
                  <h5 className="medtech-feature-title mb-3">Appointment Scheduling</h5>
                  <p className="medtech-feature-description">Still writing manual expenses? Our platform breaks down every expense you log down to the millisecond!</p>
                </div>
              </div>
            </div>

            <div className="medtech-feature-item col-lg-4 col-md-6 col-sm-12 mb-4">
              <div
                className="medtech-feature-card p-3 h-100 transition-all hover-shadow"
                data-aos="fade-up"
                data-aos-delay="600"
              >
                <div className="text-center text-lg-start">
                  <div className="medtech-image-wrapper mb-3">
                    <img
                      src={credit}
                      alt="Telemedicine"
                      className="medtech-feature-icon img-fluid"
                    />
                  </div>
                  <h5 className="medtech-feature-title mb-3">Telemedicine</h5>
                  <p className="medtech-feature-description">Have more than 1 bank account or credit/debit card? Our platform is already integrated with many banks around the world, for easier payments!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="medtech-why-choose-section" id='about'>
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12 mb-5 mb-lg-0">
              <div className="medtech-image-container" data-aos="zoom-in-up">
                <div className="medtech-image-glow"></div>
                <img
                  src={tablet}
                  alt="Medical Dashboard"
                  className="medtech-main-image"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="medtech-content-wrapper">
                <span className="medtech-section-tag" data-aos="fade-down">Why choose us</span>
                <h2 className="medtech-section-title" data-aos="fade-up">Take your hospital to the next level</h2>
                <p className="medtech-section-description" data-aos="fade-up" data-aos-delay="100">
                  In just few easy steps, you are all set to manage your business finances.
                  Manage all expenses with Spend.In all in one place.
                </p>
                <div className="medtech-benefits-wrapper">
                  <div className="medtech-benefit-item" data-aos="fade-right" data-aos-delay="200">
                    <div className="medtech-benefit-content">
                      <div className="medtech-icon-wrapper">
                        <img
                          src={icon1}
                          alt="Streamlined Operations"
                          className="medtech-benefit-icon"
                        />
                      </div>
                      <div className="medtech-benefit-text">
                        <h6 className="medtech-benefit-title">Streamlined Operations</h6>
                        <span className="medtech-benefit-description">Automatic payments help you to arrange payments on a certain date without doing it manually again.</span>
                      </div>
                    </div>
                  </div>
                  <div className="medtech-benefit-item" data-aos="fade-right" data-aos-delay="400">
                    <div className="medtech-benefit-content">
                      <div className="medtech-icon-wrapper">
                        <img
                          src={icone2}
                          alt="Enhanced Patient Care"
                          className="medtech-benefit-icon"
                        />
                      </div>
                      <div className="medtech-benefit-text">
                        <h6 className="medtech-benefit-title">Enhanced Patient Care</h6>
                        <span className="medtech-benefit-description">Our platform integrates with medical systems to provide better patient management and improved care delivery.</span>
                      </div>
                    </div>
                  </div>
                  <div className="medtech-benefit-item" data-aos="fade-right" data-aos-delay="600">
                    <div className="medtech-benefit-content">
                      <div className="medtech-icon-wrapper">
                        <img
                          src={icone3}
                          alt="Data-Driven Decisions"
                          className="medtech-benefit-icon"
                        />
                      </div>
                      <div className="medtech-benefit-text">
                        <h6 className="medtech-benefit-title">Data-Driven Decisions</h6>
                        <span className="medtech-benefit-description">Advanced analytics tools help you make informed decisions based on comprehensive healthcare data insights.</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="pricing">
        <Pricing />
      </div>
      <div className='amour mt-5'>
        <Review />
      </div>
      <div className="hero-section">
        <div className="hero-container">
          {/* Doctor image positioned absolutely */}
          <div className="hero-image-wrapper">
            <img
              src={doctorImg}
              alt="Healthcare professional"
              className="hero-img-doctor"
            />
          </div>

          {/* Content area */}
          <div className="hero-content-area">
            <div className="hero-text">
              <h2 className="hero-title">
                Affordable Plans for<br />
                Hospitals of All Sizes
              </h2>
              <div className="hero-buttons">
                <button className="btn-view-pricing">
                  View Detailed Pricing
                </button>
                <button className="btn-request-quote">
                  Request a Quote
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="contact">
        <Faq />
      </div>
      <div id="appointment">
        <Footer />
      </div>

    </div>
  );
}

export default App;